module.exports = __webpack_public_path__ + "static/media/Roboto-BoldItalic.0be9fa8f.ttf";